const pickBy = (object = {}, predicate = (v) => v) =>
  Object.fromEntries(
    Object.entries(object).filter(([k, v]) => predicate(v, k))
  );

export default pickBy;
